import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

interface SettingsContext {
  showFilterAction: boolean;
  showActiveFilters: boolean;
  showColumnFilterOnLoad: boolean;
  showGroupAction: boolean;
}

const Context = createContext<SettingsContext>({
  showActiveFilters: true,
  showFilterAction: true,
  showColumnFilterOnLoad: false,
  showGroupAction: true,
});

export const Settings = ({
  showFilterAction = true,
  showActiveFilters = true,
  showColumnFilterOnLoad = false,
  showGroupAction = true,
  children,
}: Partial<SettingsContext> & { children: ReactNode }) => (
  <Context.Provider
    value={{
      showFilterAction,
      showActiveFilters,
      showColumnFilterOnLoad,
      showGroupAction,
    }}
  >
    {children}
  </Context.Provider>
);

export const useSettings = () => useContext(Context);
